<template>
    <div>
        <h3>STEP 1. PROFIL BADAN USAHA</h3>
        <div class="my-4">
            <form
                @submit.prevent="
                    editMode ? update(helper.npbu_id) : store()
                "
                @keydown="form.onKeydown($event)"
                autocomplete="off"
            >
                <b-card>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >BENTUK BADAN <span class="text-danger">*</span>
                        </label>
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        v-model="form.bentuk_badan_id"
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :options="BentukBadan.bentuk_badan"
                                        :class="{'style-chooser': form.errors.has('bentuk_badan_id') }"
                                        placeholder="-Pilih Bentuk Badan-"
                                    ></v-select>
                                    <em
                                        v-if="form.errors.has('bentuk_badan_id') && helper.errors"
                                        class="form-text text-danger"
                                        >{{
                                            helper.errors.bentuk_badan_id[0]
                                        }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >
                            <span>
                                NIB
                            </span>
                            <span class="text-danger" v-if="form.bentuk_badan_id !== 8">*</span>
                        </label>
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        v-model="form.no_induk"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': form.errors.has('no_induk')
                                        }"
                                        placeholder="Masukkan Nomor Induk"
                                    />
                                    <em
                                        v-if="form.errors.has('no_induk') && helper.errors"
                                        class="form-text text-danger"
                                        >{{
                                            helper.errors.no_induk[0]
                                        }}</em
                                    >
                                </div>
                            </div>
                            <div>
                                <div class="text-danger font-weight-bold">
                                    Perhatian:
                                </div>
                                <ol class="p-0 ml-3">
                                    <li>
                                        Jika jenis Perorangan, masukkan NIK
                                        (Nomor Induk Kependudukan)
                                    </li>
                                    <li>
                                        Jika jenis Badan Usaha,masukkan NIB
                                        (Nomor Induk Berusaha)
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >NAMA <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        v-model="form.nama"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': form.errors.has('nama')
                                        }"
                                        placeholder="Masukkan Nama"
                                        style="text-transform: uppercase;"
                                    />
                                    <em
                                        v-if="
                                            form.errors.has(
                                                'nama'
                                            ) && helper.errors
                                        "
                                        class="form-text text-danger"
                                        >{{
                                            helper.errors.nama[0]
                                        }}</em
                                    >
                                </div>
                            </div>
                            <div>
                                <div class="text-danger font-weight-bold">
                                    Perhatian:
                                </div>
                                <ol class="p-0 ml-3">
                                    <li>
                                        Masukkan hanya nama badan usaha (contoh:
                                        PT. Indonesia Sejahtera Bersatu menjadi
                                        Indonesia Sejahtera Bersatu).
                                    </li>
                                    <li>
                                        Masukkan ejaan sesuai dengan NIB (jika
                                        Badan Usaha) atau NIK (jika Perorangan).
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </b-card>
                <div class="font-weight-bold my-3">
                    <h3>KONTAK & ALAMAT</h3>
                </div>
                <b-card class="my-3">
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >NO. HANDPHONE
                            <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        v-model="form.nomp"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': form.errors.has('nomp')
                                        }"
                                        placeholder="Masukkan Nomor Handphone"
                                    />
                                    <em
                                        v-if="
                                            form.errors.has(
                                                'nomp'
                                            ) && helper.errors
                                        "
                                        class="form-text text-danger"
                                        >{{
                                            helper.errors.nomp[0]
                                        }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold">
                            NO. TELEPON
                        </label>
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        v-model="form.notelepon"
                                        :class="{
                                            'form-control': true
                                        }"
                                        placeholder="Masukkan Nomor Telepon"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >EMAIL <span class="text-danger">*</span></label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        v-model="form.email"
                                        :class="{
                                            'form-control': true,
                                            'is-invalid': form.errors.has('email')
                                        }"
                                        placeholder="Masukkan Email"
                                    />
                                    <em
                                        v-if="
                                            form.errors.has(
                                                'email'
                                            ) && helper.errors
                                        "
                                        class="form-text text-danger"
                                        >{{
                                            helper.errors.email[0]
                                        }}</em
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >ALAMAT</label
                        >
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        v-model="form.alamat"
                                        :class="{
                                            'form-control': true
                                        }"
                                        placeholder="Masukkan Alamat"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >PROVINSI</label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        label="nama"
                                        v-model="wilayah.provinsi"
                                        :options="Wilayah.provinsi"
                                        :reduce="nama => nama.id" 
                                        placeholder="Pilih Provinsi"
                                        @input="onProvinsi(wilayah.provinsi)"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KAB./KOTA</label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        v-model="wilayah.kabkota"
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :options="Wilayah.kabkota" 
                                        placeholder="Pilih Kab./Kota"
                                        @input="onKabkota(wilayah.kabkota)"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KECAMATAN</label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        v-model="wilayah.kecamatan"
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :options="Wilayah.kecamatan"
                                        placeholder="Pilih Kecamatan"
                                        @input="onKecamatan(wilayah.kecamatan)"
                                    >
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KELURAHAN</label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <v-select
                                        v-model="form.wilayah_kelurahan_id"
                                        label="nama"
                                        :reduce="nama => nama.id"
                                        :options="Wilayah.kelurahan"
                                        placeholder="Pilih Kelurahan">
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row m-3">
                        <label class="col-md-2 col-form-label font-weight-bold"
                            >KODEPOS</label
                        >
                        <div class="col-md-4">
                            <div class="row">
                                <div class="col-sm-12">
                                    <input
                                        type="text"
                                        v-model="form.kodepos"
                                        :class="{
                                            'form-control': true
                                        }"
                                        placeholder="Masukkan Kodepos"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
                <div>
                    <b-row>
                        <b-col>
                            <b-button variant="primary" type="submit" :disabled="buttonDisable">
                                <b-spinner variant="light" label="Spinning" small v-if="isLoading"></b-spinner>
                                <span v-else>
                                    <i class="fa fa-edit" v-if="editMode"></i>
                                    <i class="fa fa-save" v-else></i>
                                </span>
                                <span v-if="editMode">
                                    Edit
                                </span>
                                <span v-else>
                                    Simpan
                                </span>
                            </b-button>
                        </b-col>
                        <b-col>
                            <b-button variant="success" class="float-right" v-if="buttonNext" @click="next">
                                <i class="fa fa-arrow-right"></i> Selanjutnya
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
// eslint-disable vue/no-unused-vars
// eslint-disable-line no-unused-vars
import npbuMixins from '@/helper/npbu/npbu'
import wilayahMixins from '@/helper/wilayah/wilayah'
import { mapState } from 'vuex';

export default {
    mixins: [npbuMixins, wilayahMixins],
    data() {
        return {
            form: new Form({
                jenis: "Badan Usaha",
                nama: "",
                no_induk: "",
                nomp: "",
                notelepon: "",
                email: "",
                alamat: "",
                wilayah_kelurahan_id: "",
                kodepos: "",
                bentuk_badan_id: ''
            }),
            // variable ketika di mode edit
            editMode: false,
            // pilihan jenis
            jenisOptions: ['Perorangan', 'Badan'],
            // wilayah
            wilayah: {
                provinsi: '',
                kabkota: '',
                kecamatan: ''
            },
            helper: {
                npbu_id: ''
            },
            user: JSON.parse(localStorage.getItem('user'))
        };
    },
    computed: {
        ...mapState([
            'Wilayah',
            'BentukBadan'
        ])
    },
    mounted () {
        // call vuex wilayah provinsi
        this.$store.dispatch('Wilayah/getProvinsi')
        // call bentuk badan vuex
        this.$store.dispatch('BentukBadan/getBentukBadan')
        const npbu_id = JSON.parse(localStorage.getItem('npbu_id'))
        // halaman edit
        if (this.$route.name == 'EditNpbu1') {
            // mixins edit npbu (lihat folder 'helper')
            this.detail(this.$route.params.id)
            this.helper.npbu_id = this.$route.params.id
        } else if (npbu_id !== null) {
            this.helper.npbu_id = npbu_id
            this.detail(this.helper.npbu_id)
            this.editMode = true
        }
    },
    methods: {
        inputJenis (jenis) {
            if (jenis == 'Perorangan') {
                this.$store.commit('Npbu/inputStep', true)
            } else if (jenis == 'Badan Usaha') {
                this.$store.commit('Npbu/inputStep', false)
            }
        },
        // tombol selanjutnya
        next () {
            if (this.$route.name == 'EditNpbu1') {
                this.$router.push({ name: 'EditNpbu2'})
            } else {
                this.$router.push({ name: 'StepNpbu2'})
            }
        }
    },
    // sebelum memasuki route
    beforeRouteLeave (to, from, next) {
        // vuex - call commit step disable
        this.$store.commit("Npbu/inputStep", false)
        next()
    },
};
</script>

<style scoped>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    border-color: red;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
</style>
